<template>
  <div
    class="location"
    :class="{ house: houseIcon, light }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'location',
  props: {
    houseIcon: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.location {
  font-weight: 500;
  padding-left: 12px;
  background-image: url('../../assets/icons/location.png');
  background-size: auto 10px;
  background-position: 0 1px;
  background-repeat: no-repeat;

  &.light {
    background-image: url('../../assets/icons/location-light.png');
  }

  &.house {
    padding-left: 14px;
    background-image: url('../../assets/icons/house.png');
  }
}
</style>
